import React, { useState } from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { driver } from 'driver.js';


export const SuggestGeneModal = ({ closeModal }: { closeModal: Function }) => {
  const [morphName, setMorphName] = useState('');
  const [geneType, setGeneType] = useState('Dom');

  const driverObj = driver({
    steps: [
      { element: '#suggest-gene-modal #morph', popover: { title: 'Gene Name', description: 'Type the name of the gene you are suggesting. Please check the gene list to verify this gene doesn\'t exist already.', position: 'bottom' } },
      { element: '#submit-gene-btn', popover: { title: 'Submit', description: 'Submit your gene suggestion for approval.', position: 'bottom' } },
    ]
  })


  const submitGene = () => {
    // check if morph name is filled out or has any non-whitespace characters
    if (!morphName || !morphName.trim()) {
      const morphInput = document.getElementById('morph');
      morphInput?.classList.add('is-invalid');
      return;
    }
    const data = {
      gene_name: morphName,
      reptile: localStorage.getItem('selectedReptile'),
      gene_type: geneType
    };
    BasicFetch({
      url: `${(window as any).serverLocation}reptile/add_gene`,

      method: 'POST',
      data: data,
      onSuccess: (data) => {
        window.alert("Gene was successfully submitted for approval");
        closeModal();
      },
      onFail: () => {
        console.log("Failed to submit gene. Please try again later.")
      }
    });
  }

  return (
    <ReptoolModal id='suggest-gene-modal' title="Suggest A Gene" showTutorial={driverObj.drive} closeModal={() => closeModal(false)} body={
      <React.Fragment>
        <div className="mt-3 d-flex flex-column has-validation">
          <h6>Gene Name:</h6>
          <div className="ui-textinput ui-corner-all ui-shadow-inset ui-textinput-text ui-body-inherit">
            <input id="morph" type="text" value={morphName} onChange={(event) => setMorphName(event.target.value)} className="w-100 form-control bg-black text-blue rounded" />
            <div className="invalid-feedback">Gene name required</div>
          </div>
        </div>
        <div className='mt-3'>
          <h6>Expression:</h6>
          <select id="gene_type" value={geneType} onChange={(event) => setGeneType(event.target.value)} className="w-100">
            <option value="Dom">Dominant</option>
            <option value="Codom">Codom</option>
            <option value="Recessive">Recessive</option>
            <option value="(Line Bred)">Line Bred</option>
            <option value="(Unproven)">Unproven</option>
          </select>
        </div>
        <div className='mt-3 d-flex flex-column'>
          <div id='submit-gene-btn' onClick={() => submitGene()} className="btn mt-3 button w-100">Submit Gene For Approval</div>
        </div>
      </React.Fragment>

    } />
  )
}